import type { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chipRoot: {
    maxWidth: '100%',
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  chipLabel: {
    display: 'block',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    userSelect: 'auto',
  },
}));
